import './new-infraction.scss';

import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, FormProvider, useForm } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@core/services/form-api-mapper.hook";
import { useQyCreateInfraction } from "@core/query/infraction.query";
import { InfractionFormRule, InfractionFormSchema } from "@core/form/form.rule";
import { infractionFormDefault } from "@core/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import HeaderContent from "@shared/ui/header-content/header-content";
import FormInfraction from "../form-infraction/form-infraction";

export function NewInfraction() {
  // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateInfraction } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Infraction is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addInfraction, isLoading: isCreating } =
    useQyCreateInfraction(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<InfractionFormSchema>({
    defaultValues: infractionFormDefault,
    resolver: zodResolver(InfractionFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: InfractionFormSchema) => {
    const formData = mapCreateInfraction(form);
    addInfraction(formData);
  };
  const handleValidateError = (err: FieldErrors<InfractionFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return (
    <div id="Infraction" className="infraction">
      <HeaderContent
        title="New Infraction"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4 bg-white">
            <FormInfraction />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewInfraction;